import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveFromComparisonSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2h3v20H2V2zm20 3v2h-8V5h8zM10 8H7v14h3V8zm2 3h3v11h-3V11zm8 3h-3v8h3v-8z" />
  </svg>
);
export default IconRemoveFromComparisonSizeM;
